const appsRouterPaths = {
  root: '/apps',
  server: '/apps/server',
};

export default appsRouterPaths;
